import { FC } from 'react';
import {
  AppCard,
  Heading,
  Text
} from 'stubben-edge-unified-frontend-react-components';

interface Props {
  title: string;
  currentStepIndex: number;
  setCurrentStepIndex: (e: number) => void;
  setCompany: (e: any) => void;
  tenants: any;
}

const SelectTenancyStep: FC<Props> = ({
  title,
  currentStepIndex,
  setCurrentStepIndex,
  setCompany,
  tenants
}) => {
  return (
    <div className="space-y-6">
      <Heading size="xs">{title}</Heading>

      {tenants?.map((i: any) => (
        <AppCard
          key={i.id}
          heading={i.company.name}
          leftSlot={
            <img
              src={
                i.company.icon
                  ? i.company.icon
                  : `https://ui-avatars.com/api/?name=${i.company.name.charAt(
                      0
                    )}&color=2A54EB&background=F1F4FF`
              }
              className="h-10 w-10 rounded-full object-contain"
            />
          }
          onClick={() => {
            setCompany(i.company);
            setCurrentStepIndex(currentStepIndex + 1);
          }}
        />
      ))}

      <div className="space-y-2 text-sm text-[#565E73]">
        <Text variant="secondary" size="xs">
          Trouble logging in? Email our support team{' '}
          <a href="mailto:support@stubbenedge.com" className="text-[#2A54EB]">
            support@stubbenedge.com
          </a>
        </Text>
      </div>
    </div>
  );
};

export default SelectTenancyStep;
